import { render, staticRenderFns } from "./goodsDialog.vue?vue&type=template&id=74636797&scoped=true"
import script from "./goodsDialog.vue?vue&type=script&lang=js"
export * from "./goodsDialog.vue?vue&type=script&lang=js"
import style0 from "./goodsDialog.vue?vue&type=style&index=0&id=74636797&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74636797",
  null
  
)

export default component.exports